import React, { createRef, useState, useEffect } from 'react';

const defaultStyles = {
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    height: '100%'
  },
  sheet: {
    zIndex: 21,
    position: 'absolute',
    top: 0,
    bottom: 0,
    willChange: 'transform',
    overflowY: 'auto',
    height: '100%'
  }
};

const sheet = createRef();

function Sheet(props) {
  const [sheetWidth, setSheetWidth] = useState(props.defaultSheetWidth);

  const saveSheetWidth = () => {
    const width = sheet.offsetWidth;

    if (width !== sheetWidth) {
      setSheetWidth(width);
    }
  };
  useEffect(() => {
    saveSheetWidth();
  }, []);
  const sheetStyle = {
    ...defaultStyles.sheet,
    ...props.styles.sheet
  };
  const rootProps = {
    className: props.rootClassName,
    style: { ...defaultStyles.root, ...props.styles.root },
    role: 'navigation',
    id: props.rootId
  };
  const hasBoxShadow = props.shadow && (props.open || props.docked);
  if (props.pullRight) {
    sheetStyle.right = 0;
    sheetStyle.transform = 'translateX(100%)';
  } else {
    sheetStyle.left = 0;
    sheetStyle.transform = 'translateX(-100%)';
  }
  if (props.docked) {
    if (sheetWidth !== 0) {
      sheetStyle.transform = `translateX(0%)`;
    }
  } else if (props.open) {
    sheetStyle.transform = `translateX(0%)`;
  }
  return (
    <div {...rootProps} className="full-height nav-bar-wrapper">
      <div
        className={props.sheetClassName}
        style={sheetStyle}
        ref={sheet}
        id={props.sheetId}
      >
        {props.sheet}
      </div>
    </div>
  );
}

Sheet.defaultProps = {
  docked: false,
  open: false,
  transitions: true,
  pullRight: false,
  shadow: true,
  styles: {},
  defaultSheetWidth: 0
};

export default Sheet;
